import { Box, Button, DialogProps } from "@mui/material";

//Components
import BasicModal from "../../components/modal/BasicModal";
import { useSnackbarHelper } from "../../components/Snackbar";
import useTodo from "../../../hooks/useTodo";

//component prop types
interface Props extends DialogProps {
  onClose: () => void;
  onCloseMainModal: () => void;
  selectedTaskIds?: any;
  caseId?: any;
  refetchProgressHistory: () => void;
}

/**
 * MarkWorkFlowConfirmationModal component for confirmation to mark as complete.
 * @component MarkWorkFlowConfirmationModal
 * @author Sanjay
 *
 */
function MarkWorkFlowConfirmationModal({
  onClose,
  onCloseMainModal,
  selectedTaskIds,
  caseId,
  refetchProgressHistory,
  ...props
}: Props) {
  const showSnackbar = useSnackbarHelper();

  const { markMultipleTodoAsComplete, ismarkMultipleTodoAsComplete } =
    useTodo(caseId);

  const handleOnSubmit = async () => {
    try {
      const selectedTasks = selectedTaskIds
        ?.filter((t: any) => !t?.isCompleted)
        .map((t: any) => t?._id); //return on task id's

      const payload = {
        selectedTasks,
      };
      const response = await markMultipleTodoAsComplete({ payload });
      const message = response?.data?.message || "Todos updated successfully";
      refetchProgressHistory();
      showSnackbar(message, "success");
      onClose();
      onCloseMainModal();
    } catch (error: any) {
      const errmgs = error?.response?.message || "Server error";
      showSnackbar(errmgs, "error");
    }
  };

  return (
    <BasicModal
      onClose={onClose}
      onSubmit={handleOnSubmit}
      isLoader={ismarkMultipleTodoAsComplete}
      title={"Complete To-Dos"}
      content={<Box>Mark selected To-Dos as completed?</Box>}
      actions={
        <>
          <Button
            color="error"
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: "capitalize" }}
            disabled={ismarkMultipleTodoAsComplete}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            type="submit"
            color="success"
            disabled={ismarkMultipleTodoAsComplete}
          >
            Complete
          </Button>
        </>
      }
      {...props}
    />
  );
}

export default MarkWorkFlowConfirmationModal;
